<template>
    <div>
        <addnav title="提问" @onBack="onBack" @doclick="doclick"></addnav>
        <div class="ipts">
            <van-field
                v-model="model.title"
                rows="1"
                autosize
                type="textarea"
                maxlength="150"
                placeholder="请输入问题"
                show-word-limit
                @blur="mf"
                clearable
            />
            <van-field
                v-model="model.content"
                rows="1"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="添加问题描述,更快获得回答"
                show-word-limit
                @blur="mk"
                clearable
            />
        </div>

        <van-popup
            v-model="pshow"
            close-on-popstate
            position="bottom"
            :style="{ height: '55%' }"
        >
            <VEmojiPicker    style="width:100%;"  :showSearch="false"   @select="selectEmoji" />
             <div class="rdelte" @click.stop="deleteindex">
                <van-icon name="close" />
            </div>
        </van-popup>
        <div class="mfooter">
           <van-icon class="icon-left" name="smile-o" @click="pshow=true" :size="30" />
        </div>
        
    </div>
</template>
<script>
import VEmojiPicker,{ emojisDefault, categoriesDefault } from 'v-emoji-picker';
export default {
    components: {
        VEmojiPicker
    },
    data(){
        return{
            model:{
                title:'',
                content:''
            },
            message1:'',
            pshow:false,
            message2:'',
            index:0
        }
    },
    mounted(){
        
        console.log(categoriesDefault);
        console.log("Total emojis:", emojisDefault.length);
    },
    methods: {
        onBack(){
            if(!this.model.title&&!this.model.content)
            {
                this.$router.back(-1);
            }
            else
            {
                this.$dialog.confirm({title:'提示',message:'内容未发布,确定放弃并返回'}).then(x=>{
                this.$router.back(-1);
                })
            }
            
        },
        doclick()
        {
            this.addquestion();
        },
        addquestion()
        {
            if(!this.model.title)
            {
                this.$toast("请输入问题");
                return;
            }
            if(!this.model.content)
            {
                this.$toast("请输入问题描述");
                return;
            }
            this.ajax.post('/api/services/app/PhoneQuestion/AddQuestion',this.model).then(x=>
            {
                this.$toast("创建成功");
                this.$router.back(-1);
            }).catch(x=>
            {
                this.$toast("创建失败");
            })
        },
        mf(){
            this.index=0;
        },
        mk(){
            this.index=1;
        },
        onshow(){

        },
        deleteindex(){
            if(this.index==0)
            {
                this.model.title=this.setmessage(this.model.title);
            }
            if(this.index==1)
            {
                this.model.content=this.setmessage(this.model.content);
            }
        },
       setmessage(val)
        {
            var ok=1;
            if(val)
            {
                if(val.length>1)
                {
                    if(this.isEmojiCharacter(val.substring(val.length-2))){
                        ok=2;
                    }
                }
                return val.substring(0,val.length-ok);
            }
           
            return "";
        },
        isEmojiCharacter(substring) {
            for ( var i = 0; i < substring.length; i++) {
                var hs = substring.charCodeAt(i);
                if (0xd800 <= hs && hs <= 0xdbff) {
                    if (substring.length > 1) {
                        var ls = substring.charCodeAt(i + 1);
                        var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
                        if (0x1d000 <= uc && uc <= 0x1f77f) {
                            return true;
                        }
                    }
                } else if (substring.length > 1) {
                    var ls = substring.charCodeAt(i + 1);
                    if (ls == 0x20e3) {
                        return true;
                    }
                } else {
                    if (0x2100 <= hs && hs <= 0x27ff) {
                        return true;
                    } else if (0x2B05 <= hs && hs <= 0x2b07) {
                        return true;
                    } else if (0x2934 <= hs && hs <= 0x2935) {
                        return true;
                    } else if (0x3297 <= hs && hs <= 0x3299) {
                        return true;
                    } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
                            || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
                            || hs == 0x2b50) {
                        return true;
                    }
                }
            }
        },
        selectEmoji(emoji) {
            if(this.index==0){
                this.model.title+=emoji.data;
            }
            if(this.index==1)
            {
                this.model.content+=emoji.data;
            }
        }
    }

}
</script>
<style lang="scss" scoped>
.mfooter{
    position: fixed;
    bottom: 0;
    height: 40px;
    left: 0;
    right: 0;
    background-color: #fff;
    line-height: 45px;
}
.icon-left{
    margin-left:10px;
}
.rdelte{
    position: fixed;
    bottom: 5px;
    right: 0;
    width: 30px;
    height: 30px;
    background-color: #ffffffa1;
    line-height: 37.5px;
    text-align: center;
}
</style>